/** Cliente da Locadora — backend /geo/v1/rentals. */

export interface Rental {
  id: number;
  device_id: number;
  device_name: string;
  cliente: string;
  telefone?: string | null;
  saida_at?: string | null;
  retorno_previsto_at?: string | null;
  retorno_real_at?: string | null;
  obs?: string | null;
  valor?: number | null;
  finalizada: boolean;
}

export interface RentalInput {
  device_id: number;
  device_name: string;
  cliente: string;
  telefone?: string | null;
  retorno_previsto_at: string; // ISO
  obs?: string | null;
  valor?: number | null;
}

const BASE = '/geo/v1/rentals';

async function req<T>(url: string, init?: RequestInit): Promise<T> {
  const r = await fetch(url, { credentials: 'include', ...init });
  if (!r.ok) throw new Error(`rentals ${r.status}`);
  if (r.status === 204) return undefined as T;
  return r.json() as Promise<T>;
}

export const rentalsApi = {
  list: () => req<Rental[]>(BASE),
  start: (body: RentalInput) =>
    req<Rental>(BASE, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(body) }),
  finish: (id: number, valor?: number | null) =>
    req<Rental>(`${BASE}/${id}/finish`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ valor: valor ?? null }),
    }),
  remove: (id: number) => req<void>(`${BASE}/${id}`, { method: 'DELETE' }),
};

export type RentalStatus = 'em_uso' | 'atrasada' | 'finalizada';

export function rentalStatus(r: Rental): RentalStatus {
  if (r.finalizada) return 'finalizada';
  if (r.retorno_previsto_at && Date.now() > new Date(r.retorno_previsto_at).getTime()) return 'atrasada';
  return 'em_uso';
}
